<template>
  <section class="detail-tab">
    <div class="abs-top-right">
      <v-button
        v-if="isEdit||isGuest"
        type="primary"
        plain
        size="small"
        @click="editClick(form.refer_ticket_id)">{{form.refer_ticket_id>0?'Refer edit Quote':'Edit Quote'}}</v-button>
    </div>
    <h2>{{productId>=80?'Quote Info':'Policy Detail'}}</h2>
    <housemaid-quote-info
      v-if="productId == 12"
      is-quote
      :formData="form" />
    <working-quote-info
      v-else-if="productId == 13"
      is-quote
      :formData="form" />
    <travel-quote-info
      v-else-if="productId == 14"
      is-quote
      :formData="form" />
    <decoration-quote-info
      v-else-if="productId == 15"
      is-quote
      :formData="form" />
    <student-quote-info
      v-else-if="productId == 16"
      is-quote
      :formData="form" />
    <homefire-quote-info
      v-else-if="productId == 17"
      is-quote
      :formData="form" />
    <personal-quote-info
      v-else-if="productId == 18"
      is-quote
      :formData="form" />
    <fire-quote-info
      v-else-if="productId == 20"
      is-quote
      :formData="form" />
    <drone-quote-info
      v-else-if="productId == 21"
      :formData="form" />
    <pet-quote-info
      v-else-if="productId == 22"
      is-quote
      :formData="form"></pet-quote-info>
    <template v-else-if="productId>=80&&!isNewSME">
      <span class="table-tab__title">Quick Quote</span>
      <sme-qucik-info
        :form-data="form"
        :sme-class-id="classId"></sme-qucik-info>
      <span class="table-tab__title">Kyc</span>
      <sme-kyc-info
        :form-data="form"
        :class-id="classId"></sme-kyc-info>
    </template>
    <template v-else-if="isNewSME">
      <new-sme-kyc-info
        :form-data="form"
        is-quote></new-sme-kyc-info>
    </template>
    <template v-else>
      <div class="box">
        <table class="table">
          <tr class="tr">
            <td>Effective Date</td>
            <td v-copy="formData.pcy_cmnt_date">
              {{ formData.is_eff_dt_delay?'ASAP':formData.pcy_cmnt_date }}
            </td>
          </tr>
          <template v-if="formData.class_id != 14">
            <tr
              v-if="!isHzmb"
              class="tr">
              <td>Insurance Type</td>
              <td v-copy="getOptionName('coverTypeOptions', formData.trm_of_cvr)">{{ getOptionName('coverTypeOptions', formData.trm_of_cvr) }}</td>
            </tr>
            <template v-if="!isMotorTrade">
              <tr
                v-if="!isHzmb"
                class="tr">
                <td>Sum Insured </td>
                <td v-copy="formData.isrd_vl">{{ formData.isrd_vl }}</td>
              </tr>
              <tr class="tr">
                <td>Hire Purchase Owner </td>
                <td v-copy="getOptionName('yesNoOptions', formData.hp_ind)">{{ getOptionName('yesNoOptions', formData.hp_ind) | formatYesNo }}</td>
              </tr>
              <tr
                v-if="formData.hp_ind==1"
                class="tr">
                <td>Name of Hire Purchase Owner  (If Yes for Hire purchase)</td>
                <!--              <span>{{ getLocalAllOptionName('mortgagor', formData.mortgagor) }}</span>-->
                <td
                  v-if="!isMortgagorOther"
                  v-copy="getLocalAllOptionName('mortgagor', form.mortgagor)">{{ getLocalAllOptionName('mortgagor', form.mortgagor)}}</td>
                <td
                  v-else
                  v-copy="form.mortgagor_other">{{  form.mortgagor_other}}</td>
              </tr>
              <tr
                v-if="option_benefits.length>0"
                class="tr">
                <td>Optional Benefits</td>
                <td>
                  <span
                    v-for="(item,index) in option_benefits"
                    :key="'extra'+index"
                    v-copy="item.name">{{item.name}}<br></span>
                </td>
              </tr>
              <tr
                v-if="classId==11&&extraBenefitSelect.length>0"
                class="tr">
                <td>Extra Benefits</td>
                <td>
                  <span
                    v-for="(item,index) in extraBenefitSelect"
                    :key="'extra'+index"
                    v-copy="item.name">{{item.name}}<br></span>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr class="tr">
                <td>Type of insurance</td>
                <td v-copy="getLocalAllOptionName('type_of_ins', formData.type_of_ins)">{{ getLocalAllOptionName('type_of_ins', formData.type_of_ins) }}</td>
              </tr>
              <tr class="tr">
                <td>No Claims in the past 3 years?</td>
                <td v-copy="getOptionName('yesNoOptions', formData.no_claim_3_year)">{{ getOptionName('yesNoOptions', formData.no_claim_3_year) }}</td>
              </tr>
            </template>
          </template>
        </table>
      </div>
      <div class="box">
        <h1>Policyholder Details</h1>
        <policy-holder-info :form="form" />
      </div>
      <div
        v-if="!isMotorTrade"
        class="box">
        <!--        <h1>Insured Vehicle</h1>-->
        <h1 v-if="form.class_id == 14">Insured Motorcycle Details</h1>
        <h1 v-if="form.class_id == 11||isHzmb">Insured Private Details</h1>
        <h1 v-if="form.class_id == 12">Insured Commercial Vehicle Details</h1>

        <insured-vehicle-info :form="form" />
      </div>
      <div
        v-if="isMotorTrade&&!isTPlate||!isMotorTrade"
        class="box">
        <h1>Named Driver Information</h1>
        <drivers-info :form="form" />
      </div>
    </template>
    <template>
      <h3>Previous Policy Auto-renewal Settings</h3>
      <div class="table-box">
        <div class="title flex flex-sb-center">
          <span>Auto Renew</span>
        </div>
        <div
          class="tr">
          <span>
            Client Option
          </span>
          <span
            :class="{'color-green':pre_auto_renewal_info.auto_on}">{{pre_auto_renewal_info.auto_on?'ON':'OFF'}}</span>
        </div>
      </div>
      <div class="table-box mg-b-20">
        <div class="title ">
          <span>Auto Paid Status</span>
        </div>
        <div class="tr">
          <span>Auto Paid Status</span>
          <span :class="{'color-green':pre_auto_renewal_info.paid_status==2}">{{ paid_status_lang }}</span>
        </div>
        <div class="tr">
          <span>Card Record</span>
          <span :class="{'color-red':pre_auto_renewal_info.paid_status == 3}">
            <p
              v-if="card_info.brand"
              :class="{'color-red':pre_auto_renewal_info.paid_status == 3}">{{card_info.brand}}  {{`${formatCardNumber(card_info.bin)}`}}{{card_info.last4}}</p>
            <p
              v-if="pre_auto_renewal_info.emit_at"
              class="mg-t-8"
              :class="{'color-red':pre_auto_renewal_info.paid_status == 3}"
            >{{pre_auto_renewal_info.emit_at}}</p>
            <p
              v-if="pre_auto_renewal_info.error_tip"
              class="color-red mg-t-8">
              <font-awesome-icon
                class="color-red mg-r-8"
                icon="circle-exclamation"></font-awesome-icon>
              <span class="color-red">{{pre_auto_renewal_info.error_tip }}</span>
            </p>
          </span>
        </div>
        <div class="tr">
          <span>Expected Auto Paid Date</span>
          <span>{{ pre_auto_renewal_info.auto_pay_at}}</span>
        </div>
        <div class="tr">
          <span>Auto Paid Date</span>
          <span :class="{'color-green':pre_auto_renewal_info.succeed_at}">{{ pre_auto_renewal_info.succeed_at||'-' }}</span>
        </div>
      </div>
    </template>
    <div
      v-if="productId!=80"
      class="box">
      <h1>Referrer Detail</h1>
      <table class="table">
        <tr
          class="tr">
          <td>Referrer</td>
          <td
            v-if="referrer"
            class="flex-column">
            <router-link
              :to="{path:'/accounts/detail',query:{customer_id:referrer.id}}"
              class="flex flex-wrap text-decoration-none">
              <span
                class="referrer"
                @click="handlerUser(referrer.id)"
              >{{referrer.identity==2?referrer.isrd_com_nm:`${referrer.isrd_lst_nm||''} ${referrer.isrd_fst_nm||''}`}}</span>
            </router-link>
            <p
              v-if="referrer.send_mobile"
              class="color-gray tip mg-b-5">{{referrer.send_mobile}}</p>
            <div class="tags">
              <span
                v-if="referrer.is_tier_base"
                class="span-status blue">
                Professional
              </span>
              <span
                v-if="referrer.verify_language"
                class="span-status"
                :class="{
                  'verified': referrer.verified == 20,
                  'pending_verify ': referrer.verified == -1,
                  'not_verify': referrer.verified == -2
                }">
                {{ referrer.verify_language }}
              </span>
              <span
                v-if="referrer.is_flagged"
                class="span-status flag">
                Flagged
              </span>
            </div>
          </td>
        </tr>
        <tr
          v-if="form.discount_str&&!isFina"
          class="tr">
          <td>Referrer Discount</td>
          <td>{{form.discount_str}}</td>
        </tr>
      </table>
    </div>

    <div
      v-if="sign_pic"
      class="box">
      <h3>Signature</h3>
      <div class="sign_pic">
        <img :src="sign_pic"/>
      </div>
    </div>
  </section>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import MixinFormat from '@/mixins/format'
import MixinOptions from '@/mixins/options'
import InsuredVehicleInfo from '@/views/components/insured-vehicle-info'
import PolicyHolderInfo from '@/views/tickets/components/info/policy-holder-info'
import DriversInfo from '@/views/tickets/components/info/drivers-info'
import HousemaidQuoteInfo from '@/views/components/modules/housemaid/housemaid-quote-info'
import WorkingQuoteInfo from '@/views/components/modules/working/working-quote-info'
import PersonalQuoteInfo from '@/views/components/modules/personal/personal-quote-info'
import DecorationQuoteInfo from '@/views/components/modules/decoration/decoration-quote-info'
import HomefireQuoteInfo from '@/views/components/modules/homefire/homefire-quote-info'
import fireQuoteInfo from '@/views/components/modules/homefire/fire-quote-info'
import StudentQuoteInfo from '@/views/components/modules/student/student-quote-info'
import TravelQuoteInfo from '@/views/components/modules/travel/travel-quote-info'
import DroneQuoteInfo from '@/views/components/modules/drone/drone-quote-info'
import PetQuoteInfo from '@/views/components/modules/pet/pet-quote-info'
import smeKycInfo from '@/views/quoting/sme/component/smeKycInfo'
import smeQucikInfo from '@/views/quoting/sme/component/smeQucikInfo'
import NewSmeKycInfo from '@/views/sme/components/kycInfo'

export default {
  name: 'DetailTab',
  components: {
    PolicyHolderInfo,
    InsuredVehicleInfo,
    DriversInfo,
    HousemaidQuoteInfo,
    DecorationQuoteInfo,
    HomefireQuoteInfo,
    WorkingQuoteInfo,
    PersonalQuoteInfo,
    StudentQuoteInfo,
    TravelQuoteInfo,
    fireQuoteInfo,
    DroneQuoteInfo,
    smeKycInfo,
    smeQucikInfo,
    NewSmeKycInfo,
    PetQuoteInfo
  },
  mixins: [MixinOptions, MixinFormat],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {}
    }
  },
  computed: {
    ...mapState('quote', ['carModelOptions']),
    isHzmb(){
      let {class_id} = this.form||{}
      return class_id==15
    },
    pre_auto_renewal_info(){
      let {pre_auto_renewal_info} = this.form||{}
      return pre_auto_renewal_info||{}
    },
    card_info(){
      let {card_info} = this.pre_auto_renewal_info||{}
      return card_info||{}
    },
    paid_status_lang(){
      let {paid_status} = this.pre_auto_renewal_info||{}
      let obj = {
        1:'Pending',
        2:'Success ',
        3:'Invalid',
        4:'Sign and Pay'
      }
      return obj[paid_status]
    },
    sign_pic(){
      let {upload_document={},sign_pic={}} = this.formData
      let sign_data = sign_pic||{}
      if(this.productId==80){
        let {sign_files=[{}]} = upload_document||{}
        sign_data = sign_files[0]||{}
      }
      return sign_data.url
    },
    referrer(){
      let {referrer} = this.formData||{}
      return referrer||{}
    },
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    isNewSME(){
      let {sme_versions} = this.form||{}
      return sme_versions==3
    },
    productId() {
      return this.form.product_id || 11
    },
    classId() {
      return this.formData.class_id || 14
    },
    localAllOptions() {
      if(this.classId === 14) {
        return this.allOptions
      } else {
        return this[`allOptions${this.classId}`]
      }
    },
    businessPurposes() {
      if(!this.localAllOptions.business_purposes || !this.formData.business_purposes) {
        return []
      }
      return this.localAllOptions.business_purposes.filter(item => {
        return this.formData.business_purposes.includes(item.id)
      })
    },
    isEdit(){
      const {stts} = this.form
      return stts < 401
    },
    isMortgagorOther(){
      let motorList = this.localAllOptions.mortgagor
      let {mortgagor}=this.formData
      let list = motorList.filter(item=>{
        return item.id==mortgagor
      })
      return list.length>0&&list[0].is_other==1?true:false
    },
    extraBenefitSelect(){
      let {extra_benefits_content={}} = this.formData||{}
      let arr =[]
      if(extra_benefits_content){
        arr = Object.entries(extra_benefits_content).map(item=>item[1])
      }
      return arr||[]
    },
    option_benefits(){
      let benefitsList = this.localAllOptions.benefits || []
      let arr =[]
      let {benefits=[]} = this.formData||{}
      if(benefitsList.length > 0){
        arr = benefitsList.filter(item => {
          return benefits.includes(item.id)
        })
      }
      return arr
    },
    isGuest(){
      let {customer} = this.form||{}
      return customer==[]||customer==null||customer==''
    },
    isMotorTrade(){
      let {class_id} = this.form||{}
      return class_id ==13
    },
    isTPlate(){
      let {type_of_ins} = this.form||{}
      return type_of_ins ==1
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        this.formData = val
      }
    },
    'formData.brand_id': {
      immediate: true,
      deep: true,
      handler(val, old) {
        if(val && this.classId == 11) {
          this.updateCarModelOptions({
            val,
            time: new Date().getTime()
          })
        }
      }
    }
  },

  methods: {
    ...mapActions('quote', ['updateCarModelOptions']),
    getLocalAllOptionName(target, value) {
      if(this.classId == 14) {
        return this.getAllOptionName(target, value)
      } else {
        return this[`getAllOptionName${this.classId}`](target, value)
      }
    },
    editClick(ticket_id) {
      if(ticket_id>0)
        this.$router.push({
          path:'/tickets/detail',
          query:{
            ticket_id
          }
        })
      else
        this.$emit('edit',true)
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/.sme-container__info{
  margin-bottom: 30px;
  .box{
    width: 100%;
    max-width: 100%;
  }
}
.detail-tab {
    position: relative;
  .table-tab__title{
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    padding: 20px 0;
    color: #24292E;
    display: inline-block;
    border-top: 1px solid #D1D5DA;
    width: 100%;
  }
  .box {
    margin-bottom: 15px;
    h1 {
        padding-bottom: 10px;
      font-size: 24px;
      color: #616266;
    }
    ul {
      li {
        display: flex;
        padding: 5px;
        list-style: none;
        color: #606266;
        font-size: 12px;
        line-height: 14px;
        border-bottom: 1px solid #dddfe7;
        &:nth-child(2n) {
          background: rgba(0, 0, 0, 0.02);
        }
        span {
          flex: 1;
        }
        span:first-child {
          font-weight: bold;
        }
      }
    }
  }
  .asap{
    font-weight: bold;
    color: black;
    margin-left: 5px;
  }
}
.sign_pic {
  display: flex;
  justify-content: center;
  background: white;
  img{
    width: 300px;
  }
}
.table-box {
  & + .table-box{
    margin-top: 30px;
  }
  .title{
    width: 100%;
    font-weight: 600;
    font-size: 14px;
    height: 52px;
    background: #F6F8FA;
    border: 1px solid #E1E4E8;
    border-radius: 6px 6px 0px 0px;
    display: flex;
    justify-content: space-between;
    span{
      padding: 16px;
      display: inline-block;
    }
  }
  .hd{
    border-radius: 6px;
    cursor: pointer;
    span{
      padding: 16px 0;
    }
    .title-name{
      padding-left: 16px;
      font-weight: 600;
      font-size: 14px;
      color: #0366D6;
    }
    .money{
      margin: 0 6px;
      padding: 0px 6px;
      height: 16px;
      background: rgba(209, 213, 218, 0.5);
      border-radius: 100px;
      font-weight: 600;
      color: #24292E;
      line-height: 16px;
    }
    .icon{
      font-weight: 900;
      font-size: 16px;
      color: #0366D6;
    }
    .code{
      float: right;
      padding-right: 16px;
      color: #586069;
    }
  }
  .tr {
    display: flex;
    border: 1px solid #D1D5DA;
    border-top: 0;
    padding: 8px 16px;
    span{
      flex: 1;
      &:first-child{
        font-weight: 600;
        font-size: 14px;
        color: #586069;
      }
      &:last-child{
        color: #24292E;
        font-size: 14px;
      }
    }
    .email{
      .icon{
        font-weight: 900;
        font-size: 14px;
        margin-left: 9px;
      }
      .check{
        color: #22863A;
      }
    }

    .column{
      flex-direction: column;
      align-items: start !important;
    }

    .purple{
      color: #6F42C1 !important;
      .icon{
        margin-right: 4px;
      }
    }

    .column-box {
      flex: 1;
      display: flex;
      flex-direction: column;
      .status{
        color: #B08800;
        font-size: 12px;
        font-weight: 600;
        display: inline-block;
        margin-left: 8px;
      }
      .mt-5 + .mt-5{
        margin-top: 5px;
      }
    }
    &:last-child{
      border-radius: 0px 0px 6px 6px;
    }
    .name{
      color: #0366D6 !important;
      cursor: pointer;
      text-decoration: none;
    }
    .unname{
      font-style: italic;
      cursor: pointer;
      color: #6A737D !important;
    }
  }
}
.color-green{
  color: #22863A!important;
}
</style>


